import { ReactElement, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { DataGrid, EditInPlace } from "ui";
import { importStoredList, StoredReplaceList } from "./replace-list-store";

export default function ImportReplaceListButton(): ReactElement {
  const { t } = useTranslation();
  const [lists, setLists] = useState<StoredReplaceList[]>([]);
  const [selected, setSelected] = useState<StoredReplaceList[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSelected(lists);
  }, [lists]);

  return (
    <div>
      <input
        hidden
        accept=".json"
        id="importreplacelistinput"
        type="file"
        onChange={async (e) => {
          const files = e.target.files;
          if (files) {
            setLoading(true);
            const text = await files[0].text();
            const lists = JSON.parse(text);
            setLists(lists);
            setLoading(false);
          }
        }}
      />
      <Button
        variant="text"
        color="inherit"
        onClick={() => {
          const elem = document.getElementById(
            "importreplacelistinput"
          ) as HTMLInputElement | null;
          if (elem) {
            // Reset value, otherwise importing the same file two times in a row will not trigger change event
            elem.value = "";
            elem.click();
          }
        }}
      >
        {t("Import")}
      </Button>
      <Dialog open={loading || !!lists.length} onClose={() => setLists([])}>
        <DialogTitle>{t("Import lists")}</DialogTitle>
        <DialogContent>
          {loading ? (
            t("Loading list content")
          ) : (
            <DataGrid
              rows={lists}
              columns={[
                {
                  name: t("Name"),
                  field: "name",
                  Component({ row }) {
                    return (
                      <EditInPlace
                        text={row.name}
                        onEdit={(newName) => {
                          const newSelected = [...selected];
                          const list = newSelected.find(
                            (list) => list._id === row._id
                          );
                          if (list) {
                            list.name = newName;
                            setSelected(newSelected);
                          }
                        }}
                      />
                    );
                  },
                },
                {
                  name: t("Replacements"),
                  get(row) {
                    return row.replacements.length;
                  },
                },
              ]}
              selected={selected}
              setSelected={setSelected}
              idField="_id"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLists([])}>{t("Cancel")}</Button>
          <Button
            onClick={() => {
              for (const list of selected) {
                importStoredList(list);
              }
              setLists([]);
            }}
          >
            {t("Import")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
